import useSearchMagazines from '@/entities/magazine/hook/useSearchMagazines';
import { FaqPageQueries } from '@/entities/magazine/model/magazine';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { MagazineLineItemVo, MagazineType } from '@/types/magazine';

interface useFaqViewModel {
  queries: FaqPageQueries;
  faqs: Array<MagazineLineItemVo>;
  isFaqsLoading: boolean;
  onClickFaqDetail: (faqPid: string) => void;
  totalPage: number;
}
const useFaqViewModel = (): useFaqViewModel => {
  const { moveToPage, router } = useCustomRouter();
  const { page = '1' } = router.query as FaqPageQueries;
  const {
    magazines: faqs,
    isLoading: isFaqsLoading,
    totalPage,
  } = useSearchMagazines({
    size: 20,
    page: Number(page),
    categoryIds: [],
    contentTypes: [MagazineType.FAQ],
  });

  const onClickFaqDetail = (faqPid: string) => {
    moveToPage({
      webLink: `${ROUTES.FAQ.DETAIL.path}/${faqPid}`,
      mobileScreenName: ROUTES.FAQ.DETAIL.appScreenName,
      params: {
        id: faqPid,
      },
    });
  };

  return {
    queries: {
      page,
    },
    totalPage,
    faqs,
    isFaqsLoading,
    onClickFaqDetail,
  };
};

export default useFaqViewModel;
